import React, { useState } from 'react'
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from '../../../components/ui/alert-dialog'
import { Loader2, PlusIcon, SearchIcon } from 'lucide-react'
import { Label } from '../../../components/ui/label'
import { Input } from '../../../components/ui/input'
import { useMutation } from '@tanstack/react-query'
import axios from '../../../lib/axios'
import { useAuth } from '../../../context/AuthProvider';
import { Button } from '../../../components/ui/button'
import { Trans } from "@lingui/react/macro"

const SearchCustomer = ({ onPickCustomer }:{onPickCustomer:(customer:ICustomer)=>void}) => {
    const { auth } = useAuth()

    const [open, setopen] = useState<boolean>(false);

    const [name, setname] = useState('');
    const [street, setstreet] = useState('');
    const [postcode, setpostcode] = useState('');
    
    const { mutate:searchCustomers, data:customers, reset:resetSearchCustomers, isPending:isSearchingCustomers } = useMutation<ICustomer[]>({
        mutationKey: [`customers-${name}-${street}-${postcode}`],
        mutationFn: async () => {
            const { data } = await axios.get(`locations/list`, { params: {
                dbid: auth.data?.databases[0].dbid,
                name: name,
                street: street,
                postalcode: postcode
            }})

            return data?.locations || []
        }
    })

    function resetSearch () {
        resetSearchCustomers()
        setname(''); setstreet(''); setpostcode('')
    }

  return (
    <AlertDialog open={open} onOpenChange={setopen}>
        <AlertDialogTrigger asChild><button className='flex items-center justify-center rounded-full h-7 w-7 bg-primary text-primary-foreground'><SearchIcon className='w-4 h-4'/></button></AlertDialogTrigger>
        <AlertDialogContent>
            <AlertDialogHeader>
                <AlertDialogTitle><Trans>Klant</Trans></AlertDialogTitle>
                <AlertDialogDescription><Trans>Vul onderstaande filters in om een klant te zoeken</Trans></AlertDialogDescription>
            </AlertDialogHeader>
            
            <div className='overflow-auto max-h-80'>
                {(customers && customers?.length > 0) &&
                <div className='flex flex-col gap-2'>
                    {customers?.map((customer)=>(
                        <div className='flex items-center justify-between p-2 rounded-md bg-neutral-50'>
                            <div>
                                <p className='text-sm font-medium'>{customer?.m_sNAME}</p>
                                <p className='text-xs text-neutral-400'>{customer?.STREET} {customer?.NR} {customer?.POBOX}</p>
                                <p className='text-xs text-neutral-400'>{customer?.POSTALCODE} {customer?.CITY} {customer?.COUNTRYCODE}</p>
                            </div>
                            <button onClick={()=>{onPickCustomer(customer); setopen(false)}} className='flex items-center justify-center w-8 h-8 border rounded-full text-primary'><PlusIcon className='w-4 h-4'/></button>
                        </div>
                    ))}
                </div>
                }

                {(!customers || customers?.length === 0) && 
                <div className='flex flex-col gap-4'>
                    <div>
                        <Label><Trans>Naam</Trans><span className='ml-1 text-red-600'>*</span></Label>
                        <Input value={name} onChange={(e)=>{setname(e.currentTarget.value)}}/>
                    </div>
                    <div>
                        <Label><Trans>Straat</Trans></Label>
                        <Input value={street} onChange={(e)=>{setstreet(e.currentTarget.value)}}/>
                    </div>
                    <div>
                        <Label><Trans>Postcode</Trans></Label>
                        <Input value={postcode} onChange={(e)=>{setpostcode(e.currentTarget.value)}}/>
                    </div>
                </div>
                }
            </div>

            <AlertDialogFooter>
                <AlertDialogCancel><Trans>Sluiten</Trans></AlertDialogCancel>
                {(customers && customers?.length > 0) && <Button onClick={()=>{resetSearch()}}><Trans>Reset zoekopdracht</Trans></Button>}
                {(!customers || customers?.length === 0) && 
                <Button disabled={isSearchingCustomers || name?.length === 0} onClick={()=>{searchCustomers()}}>
                    {isSearchingCustomers && <Loader2 className='w-4 h-4 animate-spin'/>}
                    <Trans>Zoeken</Trans>
                </Button>}
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
  )
}

export default SearchCustomer